import React, { useState, useEffect } from "react";

import { Link } from "react-scroll";
import { SidebarData } from "./SidebarData";
import { ExecutiveSidebarData } from "./ExecutiveSidebarData";
import { AdminSidebarData } from "./AdminSidebarData";
import { EntitySidebarData } from "./EntitySidebarData";
import "./Navbar.css";
import config from "../../config.json";

import { MDBBtn } from "mdb-react-ui-kit";

import { GiHamburgerMenu } from "react-icons/gi";

function Navbar({
  setLoggedIn,
  userType,
  setActiveSidebarData,
  activeSidebarData,
  userName,
}) {
  const [sidebar, setSidebar] = useState(true);
  const [hamburger, setHamburger] = useState(false);
  const [sideBarTextVisible, setSideBarTextVisible] = useState(true);
  // const [popupMarginLeft, setPopupMarginLeft] = useState(
  //   document.getElementById("navPopup").style.marginLeft
  // );
  // const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    showHamburger();
  }, [hamburger]);

  function showHamburger() {
    //setHamburger(!hamburger);
    var x = document.getElementById("navBarTop");
    if (x.className === "navbar-flex-container") {
      x.className += " navbar-responsive";
    } else {
      x.className = "navbar-flex-container";
    }
    var windowInnerWidth = `${window.innerWidth}px`;

    if (hamburger) {
      document.getElementById("navPopup").style.marginLeft = "0px";

      return;
    }
    document.getElementById("navPopup").style.marginLeft = windowInnerWidth;
  }

  function showSidebar() {
    setSidebar(!sidebar);

    if (sidebar) {
      setTimeout(() => {
        setSideBarTextVisible(!sideBarTextVisible);
      }, 100);

      document.getElementById("mainDiv").style.marginLeft = "250px";
      document.getElementById("mainDiv").style.transition = "350ms";
    } else {
      setSideBarTextVisible(!sideBarTextVisible);
      document.getElementById("mainDiv").style.marginLeft = "0px";
      document.getElementById("mainDiv").style.transition = "350ms";
    }
  }

  useEffect(() => {
    switch (userType) {
      case 0:
        setActiveSidebarData(AdminSidebarData);
        break;
      case 1:
        setActiveSidebarData(ExecutiveSidebarData);
        break;
      case 2:
        setActiveSidebarData(EntitySidebarData);
        break;
      default:
        setActiveSidebarData(SidebarData);
        break;
    }
    // console.log(activeSidebarData);
  }, []);

  window.addEventListener("orientationchange", function (e) {
    if (hamburger) {
      setHamburger(false);
      return;
    }
    this.setTimeout(() => {
      showHamburger();
    }, 300);
  });

  const logoutUser = async (e) => {
    const response = await fetch(
      config.domainName + ":" + config.port + "/api/logout",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      }
    );

    const content = await response.json();

    setLoggedIn(false);
  };

  return (
    <div>
      <div className="navbar">
        <div className="navbar-flex-container" id="navBarTop">
          <div className="navbar-brand">
            <Link to="home" spy offset={-100} key={"home"}>
              <img
                src="/mainLogos/elguards-logo-blue.svg"
                alt=""
                id="brandImage"
                loading="lazy"
                style={{
                  cursor: "pointer",
                  height: "2rem",
                }}
              />
            </Link>
          </div>
          <div
            style={{
              display: "flex",
              width: "80%",
              justifyContent: "space-between",
            }}
          >
            <div className="nav-items">
              {activeSidebarData
                ? activeSidebarData.map((item, index) => {
                    if (item.display === true) {
                      return (
                        <div id="navItem" key={index}>
                          <Link
                            to={item.to}
                            spy
                            offset={-100}
                            className={item.cName}
                            activeClass="nav-text active"
                            style={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                          >
                            {item.title}
                          </Link>
                        </div>
                      );
                    }
                  })
                : ""}
            </div>
            <div className="logout-button-in-nav">
              <MDBBtn
                color="link"
                style={{
                  color: "#0550F0",
                  width: "110px",
                }}
                onClick={logoutUser}
                className="d-flex justify-content-end"
              >
                <strong>Log Out</strong>
              </MDBBtn>
            </div>
          </div>

          <div className="hamburger-icon">
            <MDBBtn
              color="link"
              style={{
                color: "#0550F0",
                width: "110px",
                justifyContent: "center",
              }}
              onClick={() => setHamburger(!hamburger)}
              className="d-flex"
            >
              <GiHamburgerMenu />
            </MDBBtn>
            {/* <GiHamburgerMenu /> */}
          </div>
        </div>
        {/* <div className="nav-popup">
          {activeSidebarData
            ? activeSidebarData.map((item, index) => {
                if (item.display == true) {
                  return (
                    <div id="nav-pop-item">
                      <Link
                        key={index}
                        to={item.to}
                        spy
                        offset={-100}
                        className={item.cName}
                        activeClass="nav-text active"
                        style={{ textDecoration: "none", cursor: "pointer" }}
                      >
                        {item.title}
                      </Link>
                    </div>
                  );
                }
              })
            : ""}
        </div> */}
      </div>
      <div
        className="nav-popup"
        // style={{ marginLeft: `${window.innerWidth}px` }}
        id="navPopup"
      >
        <div className="nav-popup-all-items" id="navPopupItems">
          {activeSidebarData
            ? activeSidebarData.map((item, index) => {
                if (item.display === true) {
                  return (
                    <div id="nav-pop-item" key={index}>
                      <Link
                        onClick={() => setHamburger(false)}
                        to={item.to}
                        spy
                        offset={-100}
                        className="nav-popup-text"
                        activeClass="nav-popup-text active"
                        style={{ textDecoration: "none", cursor: "pointer" }}
                      >
                        <div>{item.title}</div>
                      </Link>
                    </div>
                  );
                }
              })
            : ""}
        </div>

        <div
          className="logout-in-popup"
          id="loginPopup"
          // style={{ color: "#0550F0", display: "flex", height: "60px" }}
        >
          <MDBBtn onClick={logoutUser} className="w-75 rounded-7 ">
            <strong>Log Out</strong>
          </MDBBtn>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
